import { render, staticRenderFns } from "./PdvUserConferenceDashboard.vue?vue&type=template&id=48a26385"
import script from "./PdvUserConferenceDashboard.vue?vue&type=script&lang=js"
export * from "./PdvUserConferenceDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports